__turbopack_context__.v({
  "alignBottom": "Checkbox-module-scss-module__ro62NG__alignBottom",
  "alignTop": "Checkbox-module-scss-module__ro62NG__alignTop",
  "disabled": "Checkbox-module-scss-module__ro62NG__disabled",
  "fullWidth": "Checkbox-module-scss-module__ro62NG__fullWidth",
  "label": "Checkbox-module-scss-module__ro62NG__label",
  "wrapper": "Checkbox-module-scss-module__ro62NG__wrapper",
});
